export const Textarea = {
  variants: {
    default: {
      textStyle: 'l-s',
      color: 'solid.900',
      borderRadius: '8px',
      borderWidth: '1px',
      borderColor: 'solid.100',
      _placeholder: {
        color: 'solid.300',
        opacity: 1,
      },
      _focus: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        outline: 'solid.100',
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        outline: 'solid.100',
      },
      _active: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        outline: 'solid.100',
      },
      _invalid: {
        boxShadow:
          '0px 0px 0px 3px #DF1C413D, 0px 0px 0px 2px #FFFFFF, 0px 0px 0px 1px #DF1C41, 0px 1px 2px 0px #96132C52',
        borderColor: '#DF1C41',
      },
    },
    textAreaQuestion: {
      field: {
        textStyle: 'l-s',
        fontSize: '14px',
        color: 'solid.400',
        borderBottom: '1px',
        borderColor: 'solid.50',
        ml: '20px',
        _focus: {
          color: 'solid.900',
        },
        _hover: {
          color: 'solid.900',
        },
        _active: {
          color: 'solid.900',
        },
        _invalid: {
          color: 'solid.900',
        },
      },
    },
  },

  defaultProps: {
    variant: 'default',
  },
}
